<highcharts-chart
  *ngIf="options"
  [Highcharts]="Highcharts"
  [constructorType]="'mapChart'"
  [options]="options"
  style="width: 100%; height: 100%; display: block"
/>
